/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as CancelTokenRouteImport } from './routes/cancel/$token/route'
import { Route as BookTokenRouteImport } from './routes/book/$token/route'

// Create/Update Routes

const CancelTokenRouteRoute = CancelTokenRouteImport.update({
  id: '/cancel/$token',
  path: '/cancel/$token',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/cancel/$token/route.lazy').then((d) => d.Route),
)

const BookTokenRouteRoute = BookTokenRouteImport.update({
  id: '/book/$token',
  path: '/book/$token',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/book/$token/route.lazy').then((d) => d.Route),
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/book/$token': {
      id: '/book/$token'
      path: '/book/$token'
      fullPath: '/book/$token'
      preLoaderRoute: typeof BookTokenRouteImport
      parentRoute: typeof rootRoute
    }
    '/cancel/$token': {
      id: '/cancel/$token'
      path: '/cancel/$token'
      fullPath: '/cancel/$token'
      preLoaderRoute: typeof CancelTokenRouteImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/book/$token': typeof BookTokenRouteRoute
  '/cancel/$token': typeof CancelTokenRouteRoute
}

export interface FileRoutesByTo {
  '/book/$token': typeof BookTokenRouteRoute
  '/cancel/$token': typeof CancelTokenRouteRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/book/$token': typeof BookTokenRouteRoute
  '/cancel/$token': typeof CancelTokenRouteRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/book/$token' | '/cancel/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/book/$token' | '/cancel/$token'
  id: '__root__' | '/book/$token' | '/cancel/$token'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  BookTokenRouteRoute: typeof BookTokenRouteRoute
  CancelTokenRouteRoute: typeof CancelTokenRouteRoute
}

const rootRouteChildren: RootRouteChildren = {
  BookTokenRouteRoute: BookTokenRouteRoute,
  CancelTokenRouteRoute: CancelTokenRouteRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/book/$token",
        "/cancel/$token"
      ]
    },
    "/book/$token": {
      "filePath": "book/$token/route.tsx"
    },
    "/cancel/$token": {
      "filePath": "cancel/$token/route.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
